// Translations for multi-language support
const translations = {
    en: {
        'app-title': 'Currency Converter',
        'language': 'English',
        'theme': 'Dark Mode',
        'main-title': 'Currency Converter',
        'main-subtitle': 'Convert between 200+ currencies with real-time exchange rates',
        'amount-label': 'Amount',
        'from-label': 'From',
        'to-label': 'To',
        'convert-btn': 'Convert',
        'loading': 'Converting...',
        'exchange-rate': 'Exchange Rate:',
        'last-updated': 'Last updated:',
        'error-message': 'An error occurred. Please try again.',
        'popular-currencies': 'Popular Currencies',
        'watch-list': 'Currency Watch List',
        'add-to-watch': 'Add to Watch',
        'watch-list-empty': 'No currencies in your watch list. Add some currencies to track their rates!',
        'remove-from-watch': 'Remove',
        'clear-all-watch': 'Clear All',
        'confirm-clear-watch-list': 'Are you sure you want to clear all watch list items?',
        'footer-text': 'Currency data provided by Exchange Rate API',
        'disclaimer': 'Exchange rates are for informational purposes only and may not reflect actual trading rates.',
        'now': 'Now',
        'light-mode': 'Light Mode',
        'dark-mode': 'Dark Mode',
        'chinese': '中文',
        'english': 'English',
        'conversion-history': 'Conversion History',
        'clear-history': 'Clear History',
        'history-empty': 'No conversion history yet. Perform a conversion to see it here!',
        'confirm-clear-history': 'Are you sure you want to clear all conversion history?'
    },
    zh: {
        'app-title': '货币转换器',
        'language': '中文',
        'theme': '深色模式',
        'main-title': '货币转换器',
        'main-subtitle': '支持200多种货币的实时汇率转换',
        'amount-label': '金额',
        'from-label': '从',
        'to-label': '到',
        'convert-btn': '转换',
        'loading': '转换中...',
        'exchange-rate': '汇率：',
        'last-updated': '最后更新：',
        'error-message': '发生错误，请重试。',
        'popular-currencies': '热门货币',
        'watch-list': '货币监控列表',
        'add-to-watch': '添加监控',
        'watch-list-empty': '您的监控列表为空。添加一些货币来跟踪它们的汇率！',
        'remove-from-watch': '移除',
        'clear-all-watch': '清空所有',
        'confirm-clear-watch-list': '您确定要清空所有监控列表项目吗？',
        'footer-text': '汇率数据由 Exchange Rate API 提供',
        'disclaimer': '汇率仅供参考，可能与实际交易汇率不符。',
        'now': '刚刚',
        'light-mode': '浅色模式',
        'dark-mode': '深色模式',
        'chinese': '中文',
        'english': 'English',
        'conversion-history': '兑换历史',
        'clear-history': '清空历史',
        'history-empty': '暂无兑换历史。进行一次兑换即可在此处查看！',
        'confirm-clear-history': '您确定要清空所有兑换历史吗？'
    }
};

// Currency names in different languages
const currencyNames = {
    en: {
        'usd': 'US Dollar',
        'eur': 'Euro',
        'gbp': 'British Pound',
        'jpy': 'Japanese Yen',
        'cad': 'Canadian Dollar',
        'aud': 'Australian Dollar',
        'chf': 'Swiss Franc',
        'cny': 'Chinese Yuan',
        'sek': 'Swedish Krona',
        'nzd': 'New Zealand Dollar',
        'mxn': 'Mexican Peso',
        'sgd': 'Singapore Dollar',
        'hkd': 'Hong Kong Dollar',
        'nok': 'Norwegian Krone',
        'try': 'Turkish Lira',
        'rub': 'Russian Ruble',
        'inr': 'Indian Rupee',
        'brl': 'Brazilian Real',
        'zar': 'South African Rand',
        'krw': 'South Korean Won'
    },
    zh: {
        'usd': '美元',
        'eur': '欧元',
        'gbp': '英镑',
        'jpy': '日元',
        'cad': '加拿大元',
        'aud': '澳大利亚元',
        'chf': '瑞士法郎',
        'cny': '人民币',
        'sek': '瑞典克朗',
        'nzd': '新西兰元',
        'mxn': '墨西哥比索',
        'sgd': '新加坡元',
        'hkd': '港币',
        'nok': '挪威克朗',
        'try': '土耳其里拉',
        'rub': '俄罗斯卢布',
        'inr': '印度卢比',
        'brl': '巴西雷亚尔',
        'zar': '南非兰特',
        'krw': '韩元'
    }
};

// Current language state
export let currentLanguage = localStorage.getItem('language') || 'en';

// Function to update current language (needed for ES modules)
export function setCurrentLanguage(lang) {
    currentLanguage = lang;
}

// Translation function
function t(key) {
    return translations[currentLanguage][key] || translations.en[key] || key;
}

// Get currency name in current language
function getCurrencyName(code, fullName) {
    const localizedName = currencyNames[currentLanguage][code.toLowerCase()];
    if (localizedName) {
        return `${code.toUpperCase()} - ${localizedName}`;
    }
    return `${code.toUpperCase()} - ${fullName}`;
}

// Update all translatable elements
function updateTranslations() {
    document.querySelectorAll('[data-i18n]').forEach(element => {
        const key = element.getAttribute('data-i18n');
        element.textContent = t(key);
    });
    
    // Update HTML lang attribute
    document.documentElement.lang = currentLanguage;
    
    // Update theme button text based on current theme
    updateThemeButtonText();
}

// Update theme button text
function updateThemeButtonText() {
    const themeButton = document.getElementById('themeToggle');
    const themeSpan = themeButton.querySelector('span:last-child');
    const currentTheme = document.documentElement.getAttribute('data-theme');
    
    if (currentTheme === 'dark') {
        themeSpan.textContent = t('light-mode');
    } else {
        themeSpan.textContent = t('dark-mode');
    }
}

// Initialize translations
document.addEventListener('DOMContentLoaded', function() {
    updateTranslations();
});

// Export for ES modules
export {
    translations,
    currencyNames,
    t,
    getCurrencyName,
    updateTranslations,
    updateThemeButtonText
};

